export const NO_CONFIGURATION = {
  min: 0,
  max: 0,
} as const;

export const ONLY_ONE_CONFIGURATION = {
  min: 1,
  max: 1,
} as const;

export const ONLY_TWO_CONFIGURATIONS = {
  min: 2,
  max: 2,
} as const;

export const CHART_TYPE_TO_METRICS_RULE = {
  table: NO_CONFIGURATION,
  single_value: ONLY_ONE_CONFIGURATION,
  bar: {
    min: 1,
    max: Infinity,
  },
  line: {
    min: 1,
    max: Infinity,
  },
  pie: ONLY_ONE_CONFIGURATION,
  pivot: ONLY_ONE_CONFIGURATION,
  bar_line: ONLY_TWO_CONFIGURATIONS,
  stacked: ONLY_ONE_CONFIGURATION,
} as const;

export const CHART_TYPE_TO_DIMENSIONS_RULE = {
  table: NO_CONFIGURATION,
  single_value: {
    min: 0,
    max: 1,
  },
  bar: {
    min: 1,
    max: 2,
  },
  line: {
    min: 1,
    max: 2,
  },
  pie: ONLY_ONE_CONFIGURATION,
  pivot: {
    min: 2,
    max: 4,
  },
  bar_line: ONLY_ONE_CONFIGURATION,
  stacked: ONLY_TWO_CONFIGURATIONS,
} as const;

export const REQUIRED_COMBINATIONS_RULES = {
  bar: {
    rules: [
      {
        metrics: {
          min: 1,
          max: Infinity,
        },
        dimensions: ONLY_ONE_CONFIGURATION,
      },
      {
        metrics: ONLY_ONE_CONFIGURATION,
        dimensions: ONLY_TWO_CONFIGURATIONS,
      },
    ],
  },
  line: {
    rules: [
      {
        metrics: {
          min: 1,
          max: Infinity,
        },
        dimensions: ONLY_ONE_CONFIGURATION,
      },
      {
        metrics: ONLY_ONE_CONFIGURATION,
        dimensions: ONLY_TWO_CONFIGURATIONS,
      },
    ],
  },
  table: null,
  single_value: null,
  pie: null,
  pivot: null,
  bar_line: null,
  stacked: null,
} as const;
